import axiosInstance from '@/utils/api.js'

function validation (payload) {
  payload.is_enabled = parseInt(payload.is_enabled)
}

var state = {
  editProfile: []
}

var getters = {
  EDIT_PROFILE: (state) => {
    return state.editProfile
  }
}

var mutations = {
  SET_EDIT_PROFILE: (state, payload) => {
    state.editProfile = payload
  }
}

var actions = {
  GET_EDIT_PROFILE: async (context, payload) => {
    let result = await axiosInstance.get('/settings/edit_profile')
    if (result.status === 200) {
      context.commit('SET_EDIT_PROFILE', result.data)
    }
  },
  CREATE_EDIT_PROFILE: (context, payload) => {
    validation(payload)
    return axiosInstance.post('/settings/edit_profile', payload)
  },
  UPDATE_EDIT_PROFILE: (context, payload) => {
    validation(payload)
    return axiosInstance.put('/settings/edit_profile', payload)
  },
  DELETE_EDIT_PROFILE: (context, payload) => {
    return axiosInstance.delete('/settings/edit_profile?id=' + payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/editProfile.js